/**
 * Vuba Selection Calculator Logic - Handle Based (No ID issues)
 */

(function () {
    'use strict';

    // ---------- CONFIG (Use Handles from URL) ----------
    // Example: easihold.com/products/easihold-4-1l -> handle is 'easihold-4-1l'
    const CONFIG = {
        products: {
            'Easihold': {
                '4.1L': 'easihold-4-1l-gravel-binder',
                '2L': 'easihold-2l-gravel-binder',
                '800ml': 'easihold-800ml'
            },
            'Easihold Natural': {
                '4.1L': 'easihold-4-1l-natural-gravel-binder',
                '2L': 'easihold-2l-natural-gravel-binder',
                '800ml': 'easihold-800ml'
            },
            'Vuba Stone Binder': {
                'handle': 'easihold-2l-concentrate-stone-glue'
            },
            'Vuba Mulch Binder': {
                'handle': 'easihold-2l-concentrate-mulch-glue'
            }
        }
    };

    const PRODUCT_CACHE = {};

    async function getProductData(handle) {
        if (!handle) return null;
        if (PRODUCT_CACHE[handle]) return PRODUCT_CACHE[handle];
        try {
            const res = await fetch(`/products/${handle}.js`);
            if (!res.ok) return null;
            const data = await res.json();
            PRODUCT_CACHE[handle] = data;
            return data;
        } catch (e) { return null; }
    }

    document.addEventListener('DOMContentLoaded', function () {
        const form = document.getElementById('vsc-form');
        if (!form) return;

        const results = document.getElementById('vsc-results-container');
        const cartBtn = document.getElementById('vsc-add-to-cart-btn');
        const steps = document.querySelectorAll('.vsc-step');
        const progress = document.getElementById('vsc-progress');

        let state = { area: 0, roundedArea: 0, priority: '', surface: '', application: '', tree: 'no' };
        let currentStep = 1;
        let finalRes = null;

        // Navigation (Global for simple steps)
        document.querySelectorAll('.vsc-btn--next[data-next]').forEach(btn => {
            btn.addEventListener('click', (e) => {
                const nextStep = btn.getAttribute('data-next');
                if (nextStep && validate(currentStep)) {
                    goTo(parseInt(nextStep));
                }
            });
        });
        document.querySelectorAll('[data-prev]').forEach(btn => {
            btn.addEventListener('click', () => goTo(parseInt(btn.dataset.prev)));
        });

        // Step 2 Logic
        document.getElementById('vsc-step2-next').addEventListener('click', () => {
            if (validate(2)) {
                state.priority = form.querySelector('input[name="priority"]:checked').value;
                if (state.priority === 'strength') {
                    state.surface = 'any'; state.application = 'ready';
                    goTo(7);
                } else goTo(5);
            }
        });

        // Step 6 Logic (Strict skip for Mix with Water)
        const step6Next = document.getElementById('vsc-step6-next');
        if (step6Next) {
            step6Next.addEventListener('click', async (e) => {
                e.preventDefault();
                if (validate(6)) {
                    state.application = form.querySelector('input[name="application"]:checked').value;
                    if (state.application === 'ready') {
                        goTo(7);
                    } else {
                        state.tree = 'no';
                        finalRes = runCalculation();
                        goTo(8);
                        await render(finalRes);
                    }
                }
            });
        }

        document.getElementById('vsc-step7-prev').addEventListener('click', () => {
            goTo(state.priority === 'strength' ? 2 : 6);
        });

        document.getElementById('vsc-calculate').addEventListener('click', async () => {
            if (validate(7)) {
                state.tree = form.querySelector('input[name="tree"]:checked').value;
                finalRes = runCalculation();
                goTo(8);
                await render(finalRes);
            }
        });

        if (cartBtn) {
            cartBtn.addEventListener('click', async (e) => {
                e.preventDefault();
                await addToCart(finalRes, cartBtn);
            });
        }

        function validate(s) {
            const stepEl = form.querySelector(`.vsc-step[data-step="${s}"]`);
            if (s === 1) {
                const area = parseFloat(document.getElementById('vsc-area').value);
                if (isNaN(area) || area <= 0) { alert('Enter valid area'); return false; }
                state.area = area;
                // Round up to nearest 5m² as per client requirement for Easihold logic
                state.roundedArea = Math.ceil(area / 5) * 5;
            } else if ([2, 5, 6, 7].includes(s)) {
                const checked = stepEl.querySelector('input:checked');
                if (!checked) { alert('Select an option'); return false; }
                state[checked.name] = checked.value;
            }
            return true;
        }

        function goTo(s) {
            steps.forEach(x => x.classList.remove('vsc-step--active'));
            const target = form.querySelector(`.vsc-step[data-step="${s}"]`);
            if (target) {
                target.classList.add('vsc-step--active');
                currentStep = s;
                if (progress) progress.style.width = (s / 8 * 100) + '%';
                window.scrollTo({ top: document.querySelector('.vsc-calculator-section').offsetTop - 20, behavior: 'smooth' });
            }
        }

        function runCalculation() {
            let prodName = '';
            if (state.tree === 'yes') prodName = 'Easihold Natural';
            else {
                if (state.priority === 'strength' || state.application === 'ready') prodName = 'Easihold';
                else prodName = (state.surface === 'stone') ? 'Vuba Stone Binder' : 'Vuba Mulch Binder';
            }

            let items = [];
            if (prodName.includes('Easihold')) {
                const area = state.area;
                // If the area is very small, use 800ml
                if (area <= 2) {
                    items.push({
                        prodName,
                        size: '800ml',
                        qty: 1,
                        handle: CONFIG.products[prodName]['800ml'],
                        cov: 2
                    });
                } else {
                    // Optimized calculation: 4.1L for 10m², 2L for 5m²
                    let fullTenUnits = Math.floor(area / 10);
                    let remainder = area % 10;

                    if (fullTenUnits > 0) {
                        items.push({
                            prodName,
                            size: '4.1L',
                            qty: fullTenUnits,
                            handle: CONFIG.products[prodName]['4.1L'],
                            cov: 10
                        });
                    }

                    if (remainder > 5) {
                        // Remainder > 5 requires another 4.1L
                        const existing = items.find(i => i.size === '4.1L');
                        if (existing) existing.qty += 1;
                        else items.push({
                            prodName,
                            size: '4.1L',
                            qty: 1,
                            handle: CONFIG.products[prodName]['4.1L'],
                            cov: 10
                        });
                    } else if (remainder > 0) {
                        // Remainder 1-5 requires one 2L
                        items.push({
                            prodName,
                            size: '2L',
                            qty: 1,
                            handle: CONFIG.products[prodName]['2L'],
                            cov: 5
                        });
                    }
                }
            } else {
                let size = 'Concentrate';
                let cov = (prodName === 'Vuba Stone Binder') ? 8 : 10;
                let qty = Math.ceil(state.area / cov);
                items.push({ prodName, size, qty, handle: CONFIG.products[prodName].handle, cov });
            }

            return items;
        }

        async function render(items) {
            results.innerHTML = `<div class="vsc-loading"><div class="vsc-spinner vsc-spinner--dark"></div> Loading recommendation...</div>`;

            // Fetch data for all items and store variant IDs
            const renderData = await Promise.all(items.map(async item => {
                const pData = await getProductData(item.handle);
                return {
                    ...item,
                    variantId: pData?.variants[0]?.id || null,
                    image: pData?.featured_image || null
                };
            }));

            // Filter out items without variant IDs just in case
            const validItems = renderData.filter(d => d.variantId);
            finalRes = validItems; // Update global finalRes with populated data

            let html = `
                <h2 class="vsc-title">Recommendation</h2>
                <p class="vsc-subtitle">Optimized for <strong>${state.area}m²</strong> area.</p>
            `;

            validItems.forEach(res => {
                html += `
                    <div class="vsc-result-card">
                        <div class="vsc-result-media">
                            ${res.image ? `<img src="${res.image}" alt="${res.prodName}">` : '<div class="vsc-no-image">No Image</div>'}
                        </div>
                        <div class="vsc-result-info">
                            <h3>${res.prodName} — ${res.size}</h3>
                            <p>${res.qty} Bottle${res.qty > 1 ? 's' : ''}</p>
                            <small>Covers approx. ${res.qty * res.cov}m²</small>
                        </div>
                    </div>
                `;
            });

            results.innerHTML = html;
        }

        async function addToCart(resItems, btn) {
            if (!resItems || resItems.length === 0) return;
            btn.disabled = true; btn.innerHTML = 'Adding...';

            const cartItems = resItems.map(item => ({
                id: item.variantId,
                quantity: item.qty,
                properties: {
                    'Original Area': state.area + 'm²',
                    'Calculation': `${item.qty} x ${item.size}`
                }
            }));

            try {
                const response = await fetch('/cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ items: cartItems })
                });
                if (response.ok) window.location.href = '/cart';
                else { alert('Verification failed.'); btn.disabled = false; btn.innerHTML = 'Add to Cart'; }
            } catch (e) { alert('Error. Try again.'); btn.disabled = false; btn.innerHTML = 'Add to Cart'; }
        }
    });

})();